import Rive, {Layout} from "rive-react";
import React from "react";

const RiveBackground = () => {

    return (
        <div>
            <div className="hero-backgrounds landing-page">
                <div className="hero-slider-background">
                    <Rive
                        src="/lebaran_2025_-_danai.riv"
                        layout={new Layout({fit: "cover", alignment: "bottomRight"})}
                        className="absolute w-full h-full"
                    />
                </div>
            </div>
            <div className="hero">
                <div className="hero-message-wrapper landing-page">
                    <h1 style={{
                        fontFamily: "RamadanFont",
                    }}>
                        <div className="baris-1">Selamat Hari<br/>Raya Idul Fitri</div>
                    </h1>
                    <h1>
                        <div className="baris-2">Mohon Maaf Lahir & Batin</div>
                    </h1>
                </div>
            </div>
        </div>
    );
};

export default RiveBackground;
